/* Add actualMin, actualMax  Oct 10, 2023 */
/* Amend Range, add handler for sliderMax and sliderMin  Aug 16, 2024 */
/* Amend initialize sliderMax and sliderMin in watch Sep 6, 2025 */
<template>
	<div>
		<div v-if="dataType=='number'">
			<span class="d-flex range-slider">
				<input 
					type="range" 
					:name="field"
					:min="min" 
					:max="max"
					@change="handleRange"
					v-model="sliderMin"
				/>
				<input 
					type="range" 
					:name="field"
					:min="min" 
					:max="max"
					@change="handleRange"
					v-model="sliderMax"
				/>
				<b-input  type="number" :name="field" v-model="sliderMin" @change="m_handleSliderMin" />
				<b-input  type="number" :name="field" v-model="sliderMax" @change="m_handleSliderMax"/>
			</span>
		</div>
		<div v-if="dataType=='date'">
			<span>
				<div style="display: flex">
					<label for="fromDate">From:</label>
					<b-input id="fromDate" type="date"  :name="field" v-model="d_fromDate" @change="handleDateRange" />
				</div>
				<div style="display: flex">
					<label for="toDate">To:</label>
					<b-input id="toDate" type="date"  :name="field" v-model="d_toDate" @change="handleDateRange" />
				</div>
			</span>
		</div>
	</div>
</template>

<script> 
export default {
    name: 'filterRange',
    props: {
        field: String,
		dataType:  String,
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 100
        },
        actualMin: {
            type: Number,
            default: 0
        },
        actualMax: {
            type: Number,
            default: 100
        },
		fromDate: String,
		toDate:String
    },
    data() {
        return {
			d_fromDate:null,
			d_toDate:null,
            range: {
                min: 0,
                max: 100
            },
        }
    },
	created() {},
    mounted() {
 
		
		if(this.dataType=='number'){
			this.range.min = this.min;
			this.range.max = this.max;
			}
			
		if(this.dataType=='date'){
			this.d_fromDate = this.fromDate;
			this.d_toDate = this.toDate;
			}	


    },
    computed: {
        sliderMin: {
            get() {
                const value = parseInt(this.range.min);
                return value;
            },
            set(value) {
                const data = parseInt(value);
                if (data > this.range.max) {
                    this.range.max = data;
                }
                if (data < this.range.min) this.range.min = this.min;
                this.range.min = data;
            }
        },
        sliderMax: {
            get() {
                const value = parseInt(this.range.max);
                return value;
            },
            set(value) {
                const data = parseInt(value);
                if (data < this.range.min) {
                    this.range.min = data;
                }
                if (data > this.range.max) this.range.max = this.max;
                this.range.max = data
            }
        }
    },
	watch:{
		
		min(nv,ov){console.log(`In filterRange: ${nv}`);
					this.sliderMin=nv;
					},
		max(nv,ov){console.log(`In filterRange: ${nv}`);
					this.sliderMax=nv;
					},		
		fromDate(nv,ov){this.d_fromDate=nv;},
		toDate(nv,ov){this.d_toDate=nv;},
	},
    methods: {
        handleRange() {
            this.$emit('onChange', {
                name: this.field,
                min: this.range.min,
                max: this.range.max,
				actualMin:this.actualMin,
				actualMax:this.actualMax
            })
        },
		handleDateRange(){
		this.$emit('onChange', {
                name: this.field,
                min: this.d_fromDate,
                max: this.d_toDate,
             	fromDate: this.d_fromDate,
            	toDate: this.d_toDate,				
				actualMin:this.actualMin,
				actualMax:this.actualMax

            })
		},
	m_handleSliderMin(e){
	           this.$emit('onChange', {
                name: this.field,
                min: this.sliderMin,
                max: this.range.max,
				actualMin:this.actualMin,
				actualMax:this.actualMax
            });
		},
	m_handleSliderMax(e){
	           this.$emit('onChange', {
                name: this.field,
                min: this.range.min,
                max: this.sliderMax,
				actualMin:this.actualMin,
				actualMax:this.actualMax
            });
		}
    }
}
</script>

<style scoped>
/*======= Randge Slider ======= */
.range-slider {
    width: 100%;
    margin: auto;
    text-align: center;
    position: relative;
}
.range-slider input[type="range"] {
    position: absolute;
    left: 0;
    bottom: 0;
}
input[type="number"] {
    width: 100%;
    margin-right: 0;
    border: 1px solid #ddd;
    text-align: center;
    -moz-appearance: textfield;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
input[type="number"]:invalid,
input[type="number"]:out-of-range {
    border: 2px solid #ff6347;
}
input[type="range"] {
    -webkit-appearance: none;
    width: 100%;
    margin-top: 1px;
}
input[type="range"]:focus {
    outline: none;
}
input[type="range"]:focus::-webkit-slider-runnable-track {
    background: #2497e3;
}
input[type="range"]:focus::-ms-fill-lower {
    background: #2497e3;
}
input[type="range"]:focus::-ms-fill-upper {
    background: #2497e3;
}
input[type="range"]::-webkit-slider-runnable-track {
    width: 100%;
    height: 3px;
    cursor: pointer;
    animate: 0.2s;
    background: #2497e3;
    border-radius: 1px;
    box-shadow: none;
    border: 0;
}
input[type="range"]::-webkit-slider-thumb {
    z-index: 2;
    position: relative;
    box-shadow: 0px 0px 0px #000;
    border: 1px solid #2497e3;
    height: 12px;
    width: 12px;
    border-radius: 25px;
    background: #a1d0ff;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -4px;
}
</style>